import { z } from 'zod';
import { IsoDateTime, PageMeta, PageRequest, MutationReason } from './_common.js';
export const GameConfigStatus = z.enum(['draft', 'staging', 'production', 'archived']);
export const GameConfig = z.object({
    config_id: z.string(),
    game_id: z.string(),
    version: z.number().int(),
    status: GameConfigStatus,
    config: z.record(z.unknown()),
    notes: z.string().nullable(),
    created_by: z.string(),
    created_at: IsoDateTime,
    promoted_at: IsoDateTime.nullable(),
    archived_at: IsoDateTime.nullable(),
});
export const AdminGameConfigListRequest = PageRequest.extend({
    game_id: z.string().optional(),
    status: GameConfigStatus.optional(),
});
export const AdminGameConfigListResponse = z.object({
    items: z.array(GameConfig),
    page: PageMeta,
});
export const AdminGameConfigGetRequest = z.object({
    config_id: z.string(),
});
export const AdminGameConfigGetResponse = GameConfig;
export const AdminGameConfigCreateDraftRequest = z.object({
    game_id: z.string(),
    base_config_id: z.string().nullable(),
    config: z.record(z.unknown()),
    notes: z.string().max(500).nullable().default(null),
    reason: MutationReason,
});
export const AdminGameConfigCreateDraftResponse = GameConfig;
export const AdminGameConfigPromoteRequest = z.object({
    to_status: z.enum(['staging', 'production', 'archived']),
    reason: MutationReason,
});
export const AdminGameConfigPromoteResponse = GameConfig;
export const AdminGameConfigDiffRequest = z.object({
    config_id_a: z.string(),
    config_id_b: z.string(),
});
export const AdminGameConfigDiffResponse = z.object({
    paths_changed: z.array(z.string()),
    diff: z.array(z.object({
        path: z.string(),
        a: z.unknown(),
        b: z.unknown(),
    })),
});
export const AdminConfigSimulateRequest = z.object({
    config_id: z.string(),
    spins: z.number().int().min(10000).max(100000000).default(1000000),
    bet_amount: z.number().int().min(10_000).default(10_000),
    reason: MutationReason,
});
export const AdminConfigSimulateResponse = z.object({
    simulation_id: z.number().int(),
    status: z.enum(['queued', 'running', 'completed', 'failed']),
});
export const ConfigSimulationResult = z.object({
    id: z.number().int(),
    config_id: z.string(),
    spins_run: z.number().int(),
    observed_rtp: z.number(),
    observed_hit_freq: z.number(),
    observed_volatility: z.number(),
    observed_max_win: z.number().int(),
    histogram: z.record(z.number().int()),
    free_spin_trigger_freq: z.number().nullable(),
    avg_free_spin_round_payout: z.number().nullable(),
    ran_at: IsoDateTime,
    duration_ms: z.number().int(),
    status: z.enum(['queued', 'running', 'completed', 'failed']),
    error_message: z.string().nullable(),
});
export const AdminConfigSimulationGetRequest = z.object({
    simulation_id: z.number().int(),
});
export const AdminConfigSimulationGetResponse = ConfigSimulationResult;
export const AdminConfigSimulationListRequest = PageRequest.extend({
    config_id: z.string().optional(),
});
export const AdminConfigSimulationListResponse = z.object({
    items: z.array(ConfigSimulationResult),
    page: PageMeta,
});
export const ObservedRtpSnapshot = z.object({
    game_id: z.string(),
    config_id: z.string(),
    window_start: IsoDateTime,
    window_end: IsoDateTime,
    spins: z.number().int(),
    total_bet: z.number().int(),
    total_win: z.number().int(),
    observed_rtp: z.number(),
    target_rtp: z.number(),
    drift_pct_pts: z.number(),
    alert_level: z.enum(['ok', 'warn', 'critical']),
});
export const AdminObservedRtpRequest = z.object({
    game_id: z.string().optional(),
    window_hours: z.number().int().min(1).max(720).default(24),
});
export const AdminObservedRtpResponse = z.object({
    snapshots: z.array(ObservedRtpSnapshot),
});
export const ConfigAbTest = z.object({
    id: z.number().int(),
    game_id: z.string(),
    variant_a_config_id: z.string(),
    variant_b_config_id: z.string(),
    cohort_split_pct: z.number().int(),
    starts_at: IsoDateTime,
    ends_at: IsoDateTime.nullable(),
    status: z.enum(['draft', 'active', 'paused', 'ended']),
    created_at: IsoDateTime,
});
export const EventOverlay = z.object({
    id: z.number().int(),
    game_id: z.string(),
    base_config_id: z.string(),
    override_patch: z.record(z.unknown()),
    starts_at: IsoDateTime,
    ends_at: IsoDateTime,
    status: z.enum(['scheduled', 'active', 'ended', 'cancelled']),
});
//# sourceMappingURL=math_engine.js.map